<template lang="pug">
  v-container.buttons-container
    .d-flex(v-if="authorized")
      .title Transbank Integrado:
      v-switch.ma-0(v-model="_isTransbankIntegrated")
    .buttons-grid(v-if="authorized && isTransbankIntegrated")
      v-btn.tbk-button.title(
        :dark="!loading"
        :color="colors.secondary"
        :disabled="loading"
        @click="tbkOperation('reprint', 'Reimprimiendo...', 'Reimpresión exitosa')"
        ) REIMPRIMIR ÚLTIMO VOUCHER
      v-btn.tbk-button.title(
        :dark="!loading"
        :color="colors.secondary"
        :disabled="loading"
        @click="refundDialog = !refundDialog"
        ) ANULAR VENTA A CRÉDITO
      v-btn.tbk-button.title(
        :dark="!loading"
        :color="colors.secondary"
        :disabled="loading"
        @click="tbkOperation('saleDetails', 'Imprimiendo', 'Impresión exitosa')"
        ) IMPRIMIR DETALLES DE VENTA
      v-btn.tbk-button.title(
        :dark="!loading"
        :color="colors.secondary"
        :disabled="loading"
        @click="tbkOperation('total', 'Imprimiendo', 'Impresión exitosa')"
        ) IMPRIMIR TOTALES
      v-btn.tbk-button.title(
        :dark="!loading"
        :color="colors.secondary"
        :disabled="loading"
        @click="tbkOperation('loadKeys', 'Cargando Llaves', 'Llaves cargadas exitosamente')"
        ) CARGA DE LLAVES
      v-btn.tbk-button.title(
        :dark="!loading"
        :color="colors.secondary"
        :disabled="loading"
        @click="tbkOperation('poll', 'Comprobando Funcionamiento', 'POS Transbank operativo')"
        ) REVISAR ESTADO
      v-btn.tbk-button.title(
        :dark="!loading"
        :color="colors.secondary"
        :disabled="loading"
        @click="tbkOperation('close', 'Imprimiendo Cierre', 'Cierre realizado exitosamente')"
        ) REALIZAR CIERRE
    v-dialog(
      v-model="refundDialog"
      )
      v-toolbar.ma-0(
        :color="colors.primary"
        dark).title Anular Venta a Crédito
      v-card.ma-0.pa-4
        v-form(ref="form1")
          v-text-field(
            outline
            label="N° Voucher"
            mask="############"
            ref="refund"
            v-model="refundVoucher"
            :rules="[v => !!v ? true : 'Campo Obligatorio']"
            @keydown.enter=`$refs.form1.validate() ? \
              tbkOperation('refund', 'Opere pos transbank', 'Anulación exitosa', refundVoucher) \
              : ''`
            )
    ModalSupervisor(
      :available="!authorized" 
      title="REIMPRESIÓN DE DOCUMENTOS"  
      @check-key="auth()"
      confirmMessage="Autorizar Emisión de Reportes"
      style="opacity: 0; position: fixed; top:0px; left:0px; margin-left: -1000px;"
      @closed="$router.push('/')"
      )
</template>

<script>
import ModalSupervisor from '@/components/SupervisorUniqueKey/Modal'
import { mapState, mapActions } from 'vuex'
import cashDeskOpenLeaveGuard from '@/mixins/cashDeskOpenLeaveGuard'
import cashDeskMustCloseCashGuard from '@/mixins/cashDeskMustCloseCashGuard'
export default {
    name: 'tbk-view',
    components: { ModalSupervisor },
    mixins: [cashDeskOpenLeaveGuard, cashDeskMustCloseCashGuard],
    data: () => ({
        loading: false,
        authorized: false,
        refundDialog: false,
        refundVoucher: '',
    }),
    computed: {
        ...mapState('AuthModule', ['tbk']),
        ...mapState('SessionModule', ['isTransbankIntegrated']),
        _isTransbankIntegrated: {
            get() {
                return this.isTransbankIntegrated
            },
            set(v) {
                this.setIsTransbankIntegrated(v)
            },
        },
    },
    methods: {
        tbkOperation(methodName, loadingMessage, successMessage, ...args) {
            this.loading = true
            this.loadingSnack(loadingMessage)
            this.tbk[methodName](...args)
                .then(t => {
                    this.loading = false
                    this.successSnack(successMessage)
                })
                .catch(e => {
                    this.loading = false
                    this.errSnack(e || 'Ha ocurrido un error')
                })
        },
        auth: async function() {
            this.loading = true
            let response = await this.authorize()
            if (response.is_authorized) {
                this.authorized = true
                this.loading = false
            } else {
                this.$router.push('/')
            }
        },
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            resetStateUniqueKeyModule: 'resetState',
            setUniqueKey: 'setUniqueKey',
            setPermission: 'setPermission',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
        }),
        ...mapActions('SessionModule', ['setIsTransbankIntegrated']),
        errSnack(message) {
            let payload = {
                typeMessage: 'error',
                message: {
                    title: 'Error',
                    body: message,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        successSnack(message) {
            let payload = {
                typeMessage: 'success',
                message: {
                    title: 'Éxito',
                    body: message,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        loadingSnack(message) {
            let payload = {
                typeMessage: 'info',
                message: {
                    title: 'Cargando',
                    body: message,
                },
                timeout: 0,
                showProgress: true,
                showCloseBtn: false,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
    },
    watch: {
        refundDialog(v) {
            if (v) {
                this.$nextTick(() => this.$refs.refund.focus())
                this.refundVoucher = ''
            }
        },
    },
    mounted() {
        this.setPermission(
            this.mixAuthCodePermissions.CREATE_AUTH_POS_DAILY_SALE_REPORT
        )
        document.getElementById('supervisor-modal-button').click()
    },
}
</script>

<style lang="scss" scoped>
.buttons-container {
    min-height: calc(100vh - 125px);
    .buttons-grid {
        display: grid;
        grid-template-columns: 50% 50%;
        .tbk-button {
            height: 80px;
        }
    }
}
</style>
